import { css } from '@emotion/core';

export default ({ isInvalid, actionBarActive, hasTopBorder, collapsible }) => {

  function getBoxShadow (cybs) {
    // Bottom "border" conflicts with bottom border of collapsed cards
    const hasBottomBorder = !collapsible || collapsible.isOpen;
    let boxShadow = '';
    if (hasTopBorder && hasBottomBorder) {
      boxShadow = `box-shadow: inset 0 1px ${cybs?.base?.wcag21?.stoneGrey ?? '#62798D'}, inset 0 -1px ${cybs?.base?.wcag21?.stoneGrey ?? '#62798D'};`;
    } else if (hasTopBorder) {
      boxShadow = `box-shadow: inset 0 1px ${cybs?.base?.wcag21?.stoneGrey ?? '#62798D'};`;
    } else if (hasBottomBorder) {
      boxShadow = `box-shadow: inset 0 -1px ${cybs?.base?.wcag21?.stoneGrey ?? '#62798D'};`;
    }

    return boxShadow;
  }


  return {
    headerStyle: ({ classes, cybs }) => css`
      ${getBoxShadow(cybs)}
      ${classes?.structure?.padding?.space?.left[2] ??
      'padding-left: 1rem;'}
      min-height: 3rem;
      ${actionBarActive
        ? classes?.skin?.bg?.table?.highlight ??
          'background-color: rgba(224,234,250,1);'
        : ''}
      button:not(:last-child) {
        ${classes?.structure?.margin?.space?.right[1] ??
        'margin-right: 0.5rem;'}
      }
      
      @media (max-width: 320px) {
        ${classes?.structure?.padding?.space?.right[2] ??
        'padding-right: 1rem;'}
      }
    `,
    titleStyle: ({ classes, cybs }) => css`
      b,
      h2,
      h3,
      h4 {
        font-size: 1rem;
        font-weight: bold;
        margin-bottom: 0;
        ${isInvalid
          ? cybs?.base?.wcag21?.romaRed ?? '#B3202A'
          : 'color: inherit'};
      }
      svg {
        margin-right: 5px;
        height: 1rem;
        width: 1rem;
        ${isInvalid && `
            use {
              fill: ${cybs?.base?.wcag21?.romaRed ?? '#B3202A'} !important;
            }`}
      }

      @media (max-width: 320px) {
        width: 100%;
      }
    `,
    buttonStyle: ({ classes }) => css`
      & button {
        ${classes?.structure?.margin?.space?.right[1] ??
        'margin-right: 0.5rem;'}
      }
      
      @media (max-width: 320px) {
        width: 100%;
      }
    `
  };
};
